import type { ReactNode } from 'react';
import { Box, Flex, Icon, Text } from '@/ui';

type Props = {
  description: string;
  icon: ReactNode;
  iconBg: string;
  title: string;
  /** Shows a crown in place of the chevron; the row stays clickable. */
  isLocked?: boolean;
  onClick?: () => void;
};

export const SourceChoice = ({
  description,
  icon,
  iconBg,
  title,
  isLocked,
  onClick,
}: Props) => (
  <Flex
    align="center"
    bg="white"
    borderColor="line.DEFAULT"
    borderRadius="ah-xl"
    borderStyle="solid"
    borderWidth="1px"
    cursor="pointer"
    gap={3.5}
    mb={2.5}
    px={4}
    py={3.5}
    transition="border-color .15s, box-shadow .15s"
    w="100%"
    _hover={{
      borderColor: 'rgba(0,0,0,0.2)',
      boxShadow: '0 2px 8px rgba(0,0,0,.06)',
    }}
    onClick={onClick}
  >
    <Flex
      align="center"
      bg={iconBg}
      borderRadius="ah-lg"
      flexShrink={0}
      h="40px"
      justify="center"
      w="40px"
    >
      {icon}
    </Flex>
    <Box flex={1} minW={0} textAlign="left">
      <Text color="ink.strong" fontSize="ah-control" fontWeight={700}>
        {title}
      </Text>
      <Text color="ink.muted" fontSize="ah-status" mt={0.5}>
        {description}
      </Text>
    </Box>
    {isLocked ? (
      <Icon color="magicPurple.500" flexShrink={0} icon="Crown" size={4} />
    ) : (
      <Icon color="ink.muted" flexShrink={0} icon="ChevronRight" size={4} />
    )}
  </Flex>
);
